import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationGH from "../../../../src/content/give-hope/customConfirmation";
import "../../../../src/content/give-hope/give-hope.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationGH,
  React
};